module.exports = __webpack_public_path__ + "static/media/11.114432f3.jpg";